import crownIcon from "@rosette/assets/src/crown.svg";
import Image from "next/image";
import { cn } from "@rosette/ts/src/util/cn.js";

interface PremiumIconProps {
    className?: string;
    title?: string;
}

export default function PremiumIcon({ className, title }: PremiumIconProps) {
    return (
        <Image
            className={cn("inline-block w-[1.5em] h-[1.5em] [transform:scale(1.1)] align-middle", className ?? null)}
            src={crownIcon}
            alt="Premium"
            title={title} />
    );
}
